module.exports = __webpack_public_path__ + "img/xrfl_coupon.34735a93.webp";